export const loaderPath = {
  inspectionRequests: "inspection-requests",
  inspectionProcessRequests: "inspection-process-requests",
  inspectionCompletedRequests: "inspection-completed-requests",
  manufactureRequests: "manufacture-requests",
  manufactureProcessRequests: "manufacture-process-requests",
  manufactureCompletedRequests: "manufacture-completed-requests",
  startInspectionRequest: "start-inspection-requests",
};

export const inspectionRequestColumn = [
  { label: "business-name", key: "business_name" },
  { label: "design-type", key: "design_type" },
  { label: "status", key: "status" },
  { label: "created-at", key: "created_at" },
  { label: "inspected-at", key: "inspected_at" },
  { label: "delivery-date", key: "delivery_date" },
  { label: "delivery-status", key: "delivery_status" },
  { label: "view", key: "view", align: "center" },
  { label: "action", key: "action", align: "center" },
];

export const inspectionFields = [
  {
    type: "date",
    name: "created_at_min",
    formLabel: "min-created-at",
    placeholder: "min-created-at",
    size: { xs: 12 },
  },
  {
    type: "date",
    name: "created_at_max",
    formLabel: "max-created-at",
    placeholder: "max-created-at",
    size: { xs: 12 },
  },
];

export const rejectionFields = [
  {
    formLabel: "comment",
    name: "comment",
    type: "text",
    placeholder: "rejection-comment-placeholder",
    registerOptions: {
      required: {
        value: true,
        message: "comment-field-required",
      },
    },
    size: { xs: 12 },
  },
];
